import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { AuthService } from 'app/@core/services/auth.service';
import { menu } from 'app/menu/menu';
import { universityMenu } from 'app/menu/university';
import { schoolMenu } from 'app/menu/school';
import { frontendMenu } from 'app/menu/frontend';
import { CoreMenu } from '@core/types';

@Component({
	template: `
		@if (visible) {
			<button [class]="class" (click)="btnClickedHandler($event)">
				@if (icon) {
					<fa-icon [icon]="icon"></fa-icon>
				}
				{{ diplayText }}
			</button>
		}
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class BtnCellClickRendererComponent implements ICellRendererAngularComp {
	private params: any;
	diplayText: string;
	class: string;
	icon: IconProp;
	visible = true;

	constructor(
		private _router: Router,
		private _route: ActivatedRoute,
		private _authService: AuthService
	) {}

	agInit(params: any): void {
		this.params = params;
		if (this.params.label) {
			this.diplayText = this.params.label;
		} else if (this.params.value) {
			this.diplayText = this.params.value;
		} else {
			if (this.params.icon) {
				this.icon = this.params.icon;
			} else {
				this.icon = 'pen-to-square';
			}
		}

		if (this.params.class) {
			this.class = this.params.class;
		} else if (this.params.label || this.params.value) {
			this.class = 'btn btn-primary stile-btn';
		} else {
			this.class = 'btn btn-primary btn-icon';
		}

		// Se visible è passato esplicitamente, usa solo quello (la colonna gestisce la propria logica)
		// Altrimenti usa la permission inferita dalla route
		if (this.params.visible !== undefined) {
			this.visible = this.params.visible;
		} else {
			this.visible = this.checkPermission();
		}
	}

	private checkPermission(): boolean {
		if (this.params.permission) {
			const perms = Array.isArray(this.params.permission) ? this.params.permission : [this.params.permission];
			return this._authService.hasAnyPermission(perms);
		}

		const inferred = this.inferUpdatePermissionFromRoute();
		if (!inferred) {
			return true;
		}

		return this._authService.hasPermission(inferred);
	}

	private inferUpdatePermissionFromRoute(): string | undefined {
		const url = this.normalizeUrl(this._router.url);
		if (!url) {
			return undefined;
		}

		const allMenus: CoreMenu[] = [...menu, ...universityMenu, ...schoolMenu, ...frontendMenu];
		const matched = this.findMenuByUrl(allMenus, url);
		const viewPermission = matched?.permissions?.[0];
		if (!viewPermission) {
			return undefined;
		}

		return viewPermission.endsWith('.view') ? viewPermission.replace(/\.view$/, '.update') : viewPermission;
	}

	private findMenuByUrl(items: CoreMenu[], currentUrl: string): CoreMenu | undefined {
		for (const item of items || []) {
			const itemUrl = this.normalizeUrl(item.url);
			if (itemUrl && (itemUrl === currentUrl || currentUrl.startsWith(itemUrl + '/'))) {
				return item;
			}
			if (item.children?.length) {
				const found = this.findMenuByUrl(item.children as CoreMenu[], currentUrl);
				if (found) {
					return found;
				}
			}
		}
		return undefined;
	}

	private normalizeUrl(url?: string): string {
		if (!url) {
			return '';
		}
		return url.replace(/^\/+/, '').split('?')[0].split('#')[0];
	}

	btnClickedHandler($event: Event) {
		if (this.params.onClick && typeof this.params.onClick === 'function') {
			this.params.onClick(this.params.data);
		} else if (this.params.url && this.params.data) {
			const url = this.params.url.replace(/\{(\w+)\}/g, (_: string, key: string) => this.params.data[key] ?? '');
			this._router.navigate([url], { relativeTo: this._route });
		} else {
			console.warn('Né onClick né url sono definiti.');
		}
	}

	refresh(params: ICellRendererParams) {
		return true;
	}
}
